// This is being used for the sidebar collapse in the main sidebar
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submenu", "chevron"]

  connect() {
    this.open = this.shouldBeOpen()
    this.update()
  }

  toggle() {
    this.open = !this.open
    this.update()
  }

  update() {
    this.submenuTarget.classList.toggle("hidden", !this.open)
    this.chevronTarget.style.transform = this.open ? "rotate(180deg)" : ""
    this.element.querySelector("button").setAttribute("aria-expanded", this.open)
  }

  shouldBeOpen() {
    // Adjust these paths to match your actual Rails routes if needed
    const paths = [
      "/dg/data_quality",
      "/dg/data_security",
      "/dg/data_lineage",
      "/dg/data_logging",
      "/dg/data_catalog",
      "/dg/data_versions"
    ]
    return paths.some(path => window.location.pathname.startsWith(path))
  }
}
